import { prepareStyle, useStyles } from '@creditinfo-ui/styles';
import { useLayoutEffect } from 'react';
import 'normalize.css';
import '@creditinfo-ui/fonts/open-sans.css';

const htmlStyle = prepareStyle(() => ({
  fontSize: '62.5%'
}));

const bodyStyle = prepareStyle((utils) => ({
  backgroundColor: utils.colors.gray100,
  color: utils.colors.gray700,
  fontFamily:
    "'Open Sans', -apple-system, 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  fontSize: utils.fontSizes.base,
  lineHeight: utils.lineHeights.base
}));

const boxSizingStyle = prepareStyle(() => ({
  boxSizing: 'border-box'
}));

export const useGlobalStyles = () => {
  const { applyGlobalStyle } = useStyles();

  useLayoutEffect(() => {
    applyGlobalStyle(htmlStyle, 'html');
    applyGlobalStyle(bodyStyle, 'body');
    applyGlobalStyle(boxSizingStyle, '*, *::after, *::before');
  }, [applyGlobalStyle]);
};
